import moment from 'moment';

export default class FIMenuCustomerIdentification {
	constructor(init) {
		if (init) {
			this.type = init.type;
			this.idNumber = init.idNumber;

			if (init.expirationDate) {
				this.expirationDate = moment(init.expirationDate, ['YYYY-MM-DDTHH:mm:ss', 'MM/DD/YYYY']).format('MM/DD/YYYY');
			} else {
				this.expirationDate = null;
			}

			if (init.issueDate) {
				this.issueDate = moment(init.issueDate, ['YYYY-MM-DDTHH:mm:ss', 'MM/DD/YYYY']).format('MM/DD/YYYY');
			} else {
				this.issueDate = null;
			}

			this.issuingAgency = init.issuingAgency;
			this.jurisdiction = init.jurisdiction;

			if (init.additionalIdNumbers) this.additionalIdNumbers = init.additionalIdNumbers;
			else this.additionalIdNumbers = [];
		} else {
			this.type = null;
			this.idNumber = null;
			this.issueDate = null;
			this.expirationDate = null;
			this.issuingAgency = null;
			this.jurisdiction = null;
			this.additionalIdNumbers = [];
		}
	}
}
